export enum ModificationAction {
    Increase = 'increase',
    Decrease = 'decrease',
}

export enum ValueType {
    Percentage = 'percentage',
    Fixed = 'fixed',
    /**
     * Fija el margen de ganancia a un valor concreto: el precio se recalcula desde el costo de
     * cada producto. A diferencia de los otros dos, no es un delta sobre el precio actual, así
     * que `action` (aumentar/reducir) no aplica.
     */
    Margin = 'margin',
}

export type ProductsTypes = 'inventory' | 'template' | 'service';
export type ProductsTypesRequest = 'item' | 'template' | 'service';
export const PRODUCT_TYPES_MAP: Record<ProductsTypes, ProductsTypesRequest> = {
    inventory: 'item',
    template: 'template',
    service: 'service',
};

export interface BulkUpdateData {
    section: string;
    channels: string[];
    action: ModificationAction;
    type: ValueType;
    value: number;
    productTypes: ProductsTypesRequest[];
    category?: string;
}
